<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('资料.设置资金密码')" class="nav-bar">
      <template #left>
        <img src="/img/common/icon-back.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <van-cell-group>
      <template v-if="hasPayPassword">
        <div class="c_p_j">{{ $t('资料.旧密码') }}</div>
        <van-field v-model="old_password" :placeholder="$t('资料.请输入旧密码')" type="password" />
      </template>
      <div class="c_p_j">{{ $t('资料.新密码') }}</div>
      <van-field v-model="o_new_password" :placeholder="$t('资料.请输入新密码')" type="password"/>
      <div class="c_p_j">{{ $t('资料.确认密码') }}</div>
      <van-field v-model="t_new_password" :placeholder="$t('资料.请再次输入新密码')" type="password"/>
    </van-cell-group>
    <div class="sub-btn" @click="save()">
      {{ $t('资料.提交') }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: '',
      t_new_password: '',
      old_password: '',
      userInfo: {},
      loaded: false,
    };
  },
  computed: {
    hasPayPassword() {
      return !!(this.userInfo && this.userInfo.paypassword);
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (!this.o_new_password || !this.t_new_password) {
        this.$toast.fail(this.$t('资料.请填写完整'));
        return;
      }
      if (this.hasPayPassword && !this.old_password) {
        this.$toast.fail(this.$t('资料.请输入旧密码'));
        return;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast(this.$t('资料.两次密码不一致'));
        return;
      }

      this.$http({
        method: 'post',
        data: {
          old_password: this.hasPayPassword ? this.old_password : '',
          new_password: this.o_new_password,
        },
        url: 'user_set_paypw',
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            if (this.$route.query.from === 'start') {
              this.$router.replace({ path: '/Start', query: { autoGrab: '1' } });
            } else {
              this.$router.replace({ path: '/Withdraw' });
            }
          }, 500);
          return;
        }
        this.$toast(res.msg);
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          this.loaded = true;
          return;
        }
        this.$toast(res.msg);
      });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.sub-btn{
  background: linear-gradient(#fde3ca, #e7b486);
  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.van-cell{
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  
  /deep/ .van-field__control{
    color: #f3c7a2;
  }
  &:after{
    display: none;
  }
}
.van-cell-group{
  background-color: transparent;
  &:after{
    display: none;
  }
}
.c_p_j{
  padding: 26px 30px;
  color: #f3c7a2;
  font-size: 26px;
}
</style>